export const AlexaConfig = {
    // call back url
    call_back_url: `https://${process.env['REACT_APP_DYNAMIC_LINK_DOMAIN']??process.env['react_app_dynamic_link_domain'] as string}/checkMedicine`,
    // alexa auth code
    alexa_client_id: process.env['REACT_APP_ALEXA_CLIENT_ID']??process.env['react_app_alexa_client_id'],
    alexa_scope: "alexa::skills:account_linking alexa::ask:skills:read"
};
